import React from 'react';
import AntDrawer, { DrawerProps as AntDrawerProps } from 'antd/lib/drawer';
import { FontAwesomeIcon } from '../FontAwesomeIcon';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

import './Drawer.less';
import Styles from './Drawer.module.css';

interface DrawerProps extends AntDrawerProps {
    children?: React.ReactNode;
}

const Drawer = ({ closeIcon, ...props }: DrawerProps): JSX.Element => (
    <AntDrawer
        closeIcon={closeIcon ?? <FontAwesomeIcon icon={faTimes} />}
        prefixCls={Styles.aldDrawer}
        {...props}
    />
);

export { Drawer };
export type { DrawerProps };
